import { render, staticRenderFns } from "./PsPatientBtnNewPhysicalActivity.vue?vue&type=template&id=ab88fc32&scoped=true&"
import script from "./PsPatientBtnNewPhysicalActivity.vue?vue&type=script&lang=js&"
export * from "./PsPatientBtnNewPhysicalActivity.vue?vue&type=script&lang=js&"
import style0 from "./PsPatientBtnNewPhysicalActivity.vue?vue&type=style&index=0&id=ab88fc32&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab88fc32",
  null
  
)

export default component.exports